import React from 'react';
import {Sparkles} from 'lucide-react';
import {brand, brandFont} from '../../brand';

export const CreatingStatusLine: React.FC<{visible: boolean; label?: string}> = ({
  visible,
  label = 'AI is turning your notes into custom timer.',
}) => (
  <div
    style={{
      height: 36,
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      opacity: visible ? 1 : 0,
      fontFamily: brandFont,
      fontSize: 18,
      color: 'rgba(255,255,255,0.54)',
    }}
  >
    <Sparkles size={18} color={brand.primaryLight} strokeWidth={2.4} />
    {label}
  </div>
);
